module.exports = __webpack_public_path__ + "static/media/notebook03.5daea5b8.jpg";